import React, { useState, useEffect } from 'react';
import { Container, Button, Alert as BootstrapAlert, Spinner } from 'react-bootstrap';
import { useFormats } from '../../context/formatContext';
import FormatEditor from '../../components/admin/FormatEditor';
import FormatList from '../../components/admin/FormatList';
import { trackPageView } from '../../utils/analytics';

const AdminFormats = () => {
  const { formats, loading, error, fetchFormats } = useFormats();
  const [showEditor, setShowEditor] = useState(false);
  const [editingFormat, setEditingFormat] = useState(null);
  const [alert, setAlert] = useState(null);

  // Track page view
  useEffect(() => {
    trackPageView('Admin Formats');
  }, []);

  useEffect(() => {
    fetchFormats();
  }, []);

  const handleCreateNew = () => {
    setEditingFormat(null);
    setShowEditor(true);
  };

  const handleEdit = (format) => {
    setEditingFormat(format);
    setShowEditor(true);
  };

  const handleEditorClose = () => {
    setShowEditor(false);
    setEditingFormat(null);
  };

  const handleEditorSuccess = (message) => {
    setShowEditor(false);
    setEditingFormat(null);
    setAlert({ type: 'success', message });
    fetchFormats();
  };

  const handleDeleteSuccess = (message) => {
    setAlert({ type: 'success', message });
    fetchFormats();
  };

  const handlePublishSuccess = (message) => {
    setAlert({ type: 'success', message });
    fetchFormats();
  };

  if (showEditor) {
    return (
      <FormatEditor
        format={editingFormat}
        onClose={handleEditorClose}
        onSuccess={handleEditorSuccess}
      />
    );
  }

  return (
    <Container>
      <style>
        {`
          .admin-formats-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2rem;
          }

          .btn-custom {
            background-color: #6366f1;
            color: #fff;
            text-decoration: none;
          }

          .btn-custom:hover {
            background-color: #5a5fd9;
            color: #fff;
            text-decoration: none;
          }
        `}
      </style>

      <div className="admin-formats-header">
        <h2>Import Format Management</h2>
        <Button
          variant="primary"
          onClick={handleCreateNew}
          className="btn-custom"
        >
          Create New Format
        </Button>
      </div>

      {alert && (
        <BootstrapAlert
          variant={alert.type}
          dismissible
          onClose={() => setAlert(null)}
        >
          {alert.message}
        </BootstrapAlert>
      )}

      {error && (
        <BootstrapAlert variant="danger">
          {error}
        </BootstrapAlert>
      )}

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <FormatList
          formats={formats}
          onEdit={handleEdit}
          onDeleteSuccess={handleDeleteSuccess}
          onPublishSuccess={handlePublishSuccess}
        />
      )}
    </Container>
  );
};

export default AdminFormats;
